import styled from 'styled-components';
import BREAK_POINTS from '../../../../styling/media-queries';

export default styled.div`
  @media ${BREAK_POINTS.desktop} {
    &:first-child {
      margin-right: 32px;
    }
  }
  @media ${BREAK_POINTS.desktopBig} {
    &:first-child {
      margin-right: 90px;
    }
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/calculator/selection/components/ContainerColumn.tsx